// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__dCPmt","content":"LayoutSettings_content__5Ee97"};